module.exports = __webpack_public_path__ + "static/media/david-marcu.29e91f14.jpg";